import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { getAppThemeName } from '../../../services/appTheme';
const StyledValue = styled.span `
    position: relative;
    display: block;
    color: ${props => props.appTheme === 'invoned'
    ? props.theme.primary.base
    : props.theme.secondary};
    font-size: 22px;
    font-weight: 700;

    ${props => props.hasDivider &&
    props.appTheme === 'invoned' &&
    css `
            &:before {
                position: absolute;
                content: '';
                bottom: 0;
                left: 0;
                width: 40px;
                height: 2px;
                background-color: ${props.theme.secondary};
            }
        `};

    ${props => props.hasDivider &&
    props.appTheme === 'inkassier' &&
    css `
            &:before {
                position: absolute;
                content: '';
                bottom: 0;
                left: 0;
                width: 40px;
                height: 1px;
                background-color: #e5e5e5;
            }
        `};

    ${props => props.hasDivider &&
    props.appTheme === 'inkassier' &&
    css `
            &:before {
                position: absolute;
                content: '';
                bottom: 0;
                left: 0;
                width: 40px;
                height: 1px;
                background-color: ${props.theme.secondary};
            }
        `};

    ${props => props.hasAdjacentLabel &&
    css `
            cursor: pointer;
            &:hover + * {
                opacity: 1;
                bottom: -5px;
            }
        `};

    @media only screen and (min-width: 992px) {
        font-size: 38px;
        padding-bottom: 15px;
        margin-bottom: 15px;
    }

    span {
        font-size: 12px;
    }
`;
const StatValue = props => (_jsx(StyledValue, { ...props, appTheme: getAppThemeName() }));
export default StatValue;
